import {
  USER_PHOTO,
  USER_ERROR,
  USER_DATA,
  USER_COMPANIES,
  USER_COMPANY, 
  USER_WORKER
} from "./userTypes";

const initialState = {
  photo: null,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_PHOTO:
      return { ...state, photo: action.photo };
    case USER_DATA:
      return { ...state, userData: action.userData };
    case USER_ERROR:
      return { ...state, error: action.error };
    case USER_COMPANIES:
      return { ...state, companies: action.companies };
    case USER_COMPANY:
      return { ...state, company: action.company };
      case USER_WORKER:
    return {...state, worker: action.worker}
    default:
      return state;
  }
}
